import { ModelSchema } from "simple-schema-model-validator";
import { isValidDate, validateEmail, validateRutChilean } from "src/shared/global/helpers";

export class ReservationSchemaImagenologia extends ModelSchema {
    constructor () {
        const schemaModel = {
            "uprRut": {
                "alias": "Rut", 
                "type": "string",
                "required": true,
                "validate": function(value) {
                    if(value !== '' && validateRutChilean(value).ok === false) {
                        return {
                            ok: false,
                            message: "es incorrecto"
                        }
                    }
                    
                    return {
                        ok: true
                    }
                }
            },
            "usuApePat": {
                "alias": "Apellido paterno",
                "type": "string",
                "required": true,
            },
            "usuApeMat": {
                "alias": "Apellido materno",
                "type": "string",
                "required": false,
                "defaultValue": null
            },
            "usuNombres": {
                "alias": "Nombres",
                "type": "string",
                "required": true,
            },
            "ageEmail": {
                "alias": "Correo",
                "type": "string",
                "required": true,
                "validate": function(value) {
                    return validateEmail(value);
                }
            },
            "fechaNac": {
                "alias": "Fecha nacimiento",
                "type": "string",
                "required": true,
                "validate": function (value) {
                    const [year, month, day] = value.split("-");
                    const yearCurrent = new Date().getFullYear();

                    if(new Date(`${year}/${month}/${day}`) > new Date()) {
                        return {
                            ok: false,
                            message: 'no puede superar a la fecha actual'
                        }
                    }

                    if((Number(year) < 1900 || year > yearCurrent)) {
                        return {
                            ok: false,
                            message: 'es incorrecta'
                        }
                    }

                    if(!isValidDate(value)) {
                        return {
                            ok: false,
                            message: 'es incorrecta'
                        }
                    } else {
                        return {
                            ok: true
                        }
                    }
                }
            },
        }

        super(schemaModel);
    }
}